import React from 'react'
import FormInput from './index'

interface Props {
  value: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  name: string
  placeholder?: string
  error?: string | undefined
  size?: 'sm' | 'md' | 'lg'
  className?: string
  label: string
}

const DateInput: React.FC<Props> = ({
  value,
  onChange,
  name,
  placeholder = '',
  error,
  size = 'md',
  className = '',
  label,
}) => {
  return (
    <div className={`gap-2.5 flex flex-col ${size} ${className}`}>
      <p className="leading-7 font-medium text-[#6C757D]">{label}</p>
      <div>
        <FormInput
          value={value}
          onChange={onChange}
          name={name}
          size={size}
          placeholder={placeholder}
          error={error}
          className={`custom-input `}
          type="date"
        />
      </div>
    </div>
  )
}

export default DateInput
